import toUrl from './to-url';
import hostname from './host-name';
import pathname from './path-name';
import queryString from './query-string';

type T = (value: string | URL) => string;

const f: T = (value) => {
    const url = toUrl(value);
    const wwwRegex = /^www[0-9]?\./;
    const simplified = `${hostname(url).replace(wwwRegex, '')}${pathname(url)}${queryString(url)}`;

    return simplified.toLowerCase();
};

export default f;
